import type { JSX } from "react";
import { colors, type Node } from "../theme";

interface GridLinesProps {
  nodes: Node[];
  cols: number;
  isDark: boolean;
  awakened: Set<number>;
}

export function GridLines({ nodes, cols, isDark, awakened }: GridLinesProps) {
  const lines: JSX.Element[] = [];

  nodes.forEach((node, i) => {
    const col = i % cols;

    // Horizontal line to next node
    if (col < cols - 1) {
      const nextIdx = i + 1;
      const isAwake = awakened.has(i) && awakened.has(nextIdx);
      lines.push(
        <line
          key={`h-${i}`}
          x1={node.x}
          y1={node.y}
          x2={nodes[nextIdx].x}
          y2={nodes[nextIdx].y}
          style={{
            stroke: isAwake
              ? isDark
                ? colors.cyan
                : colors.blue
              : isDark
                ? colors.base02
                : colors.base2,
            strokeWidth: isAwake ? 2 : 1,
            opacity: isAwake ? 0.6 : 0.3,
            transition: "stroke 2s ease, opacity 2s ease",
          }}
        />
      );
    }

    // Vertical line to node below
    if (i + cols < nodes.length) {
      const belowIdx = i + cols;
      const isAwake = awakened.has(i) && awakened.has(belowIdx);
      lines.push(
        <line
          key={`v-${i}`}
          x1={node.x}
          y1={node.y}
          x2={nodes[belowIdx].x}
          y2={nodes[belowIdx].y}
          style={{
            stroke: isAwake
              ? isDark
                ? colors.cyan
                : colors.blue
              : isDark
                ? colors.base02
                : colors.base2,
            strokeWidth: isAwake ? 2 : 1,
            opacity: isAwake ? 0.6 : 0.3,
            transition: "stroke 2s ease, opacity 2s ease",
          }}
        />
      );
    }
  });

  return <>{lines}</>;
}
